import { ApiService } from '../../app-lite/api/api.service';

import ApplyCreditsHtml from './credits.apply.html';

export function CreditStates (
   $stateProvider : ng.ui.IStateProvider
) {
  $stateProvider
  .state({
    controller: 'applyCreditsCtrl',
    name      : 'app.apply-credits',
    params    : {
      id: { squash: true, value: null }
    },
    templateUrl: ApplyCreditsHtml,
    url        : '/:customer_id/apply_credit/:id',
    resolve    : {
      credit  : ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> | string => $stateParams.id ? workshopAPI.get('/invoice', $stateParams.id): '',
      credits : ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/customers/invoice_list', [$stateParams.customer_id, 0, 6, 'P', 'C', 'desc', 'post_date']),
      customer: ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/customer', $stateParams.customer_id)
    }
  });
}